import Vue, { ref } from 'vue';
import { onMounted } from 'vue';
import Component from 'vue-class-component';
import { newsService } from '../../../../Services/newsService';
import { searchService } from '../../../../Services/searchService';
import CmsDataProvider from '../../../../Providers/CmsDataProvider';
import { ISearchCmsData } from '../../../../Providers/search.model';

@Component({
    name: 'Zoeken',
    components: {

    },
})
export default class Zoeken extends Vue {
    public items: any = [];
    public maxItems: number = 0;
    public allItems: any = [];
    public visibleItems = 12;
    public params: any = new URLSearchParams(document.location.search.substring(1))
    public searchQuery: string = this.params.get("query");
    public query: string = this.searchQuery;
    public content = CmsDataProvider.get<ISearchCmsData>('Search');
    public filter: any = "";
    public currentLanguage: any = (window as any).currentLanguage;

    get filteredItems() {
        if (this.filter) {
            return this.allItems.filter(i => i.category == this.filter).slice(0, this.visibleItems)
        } else {
            return this.items;
        }
    }

    get noResultsTitle() {
        return this.content.noResultsTitle.replace('{zoekterm}', this.searchQuery);
    }

    get filteredItemsLength() {
        if (this.filter) {
            return this.allItems.filter(i => i.Category == this.filter).length
        } else {
            return this.allItems.length;
        }
    }

    get categories() {
        let resArr: Array<any> = [];
        this.allItems.forEach((item) => {
            const i = resArr.findIndex(x => { return x.Category == item.category });
            if (i <= -1) {
                resArr.push({ Category: item.category, Amount: 1 });
            } else {
                let entry = resArr.find(x => x.Category == item.category);
                entry.Amount++;
            }
        });
        return resArr
    }

    public setFilter(filter) {
        this.filter = filter;
    }

    public async getAll() {
        await searchService.getByQueryLimited(this.content.index, this.query, 9999, 0, this.currentLanguage).then((result: any) => {
            this.items = result.data.results.slice(0, this.visibleItems);
            this.allItems = result.data.results;
            this.maxItems = result.data.results.length;
        });
    }

    public executeSearch() {

        if(this.query.trim().length < 3) {
            return 
        }
        this.visibleItems = 12;
        const URL = window.location.origin + window.location.pathname;
        const newURL = `${URL}?query=${this.query}`
        this.searchQuery = this.query;
        return searchService.getByQueryLimited(this.content.index, this.query, 12, 0, this.currentLanguage).then((result: any) => {
            this.items = result.data.results.slice(0, this.visibleItems);
            history.replaceState(null, '', newURL);
        });
    }

    public loadMore(numberToAdd: number) {
        this.visibleItems += numberToAdd;

        return searchService.getByQueryLimited(this.content.index, this.query, 12, this.visibleItems, this.currentLanguage).then((result: any) => {
            this.items = [...this.items, ...result.data.results];
        });
    }

    async mounted() {
        await this.getAll();
    }
}